<div class="kz-auth-light">
    <h1 class="kz-auth-light__title" *ngIf="title">{{title}}</h1>
    <div class="kz-auth-light__subTitle" *ngIf="!showFormRegister" i18n="@@auth.light.subTitle">Login or sign up to a Kozikaza account</div>
    <div class="kz-auth-light__subTitle" *ngIf="showFormRegister" ><span i18n="@@auth.light.alreadyAnAccount">Already an account ?</span>&nbsp;<span class="kz-auth-light__subTitle-link" (click)="showFormRegister=false" i18n="@@auth.light.signin">Login</span></div>
    <div class="kz-auth-light__container">
        <div class="kz-auth-light__content">
            <div class="col col-login" *ngIf="!showFormRegister">
                <h2 i18n="@@auth.light.login">Log in</h2>
                <app-signin-form-lite></app-signin-form-lite>
                <div class="kz-auth-light__actions">
                    <button type="button" (click)="login()" kzButton buttonStyle="flat" [buttonState]="submitted ? 'loading' : 'default'" [disabled]="submitted" data-cy="submitLogin"><span i18n="@@auth.light.login">Log in</span></button>
                </div>
            </div>
            <div class="col col-register">
                <h2 i18n="@@auth.light.not-account">I don't have a Kozikaza account</h2>
                <ng-container *ngIf="!showFormRegister">
                    <div class="kz-auth-light__register">
                        <p *ngIf="createAccountLabel">{{createAccountLabel}}</p>
                        <div class="kz-field-buttons">
                            <button type="button" kzButton buttonStyle="flat" buttonState="default" (click)="showFormRegister=true" data-cy="account"><span i18n="@@coaching-request.button.register">Register</span></button>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="showFormRegister">
                    <app-signup-form-lite></app-signup-form-lite>
                    <div class="kz-auth-light__actions">
                        <button type="button" (click)="register()" kzButton buttonStyle="flat" [buttonState]="submitted ? 'loading' : 'default'" [disabled]="submitted" data-cy="submitRegister"><span i18n="@@auth.light.register">Register</span></button>
                    </div>
                </ng-container>
            </div>
        </div>
        <app-legal-notice *ngIf="showFormRegister"></app-legal-notice>
    </div>
</div>
